/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const ModxIconConfig = {
  name: 'ModxIcon',
  height: 512,
  width: 448,
  svgPath: 'M356 241.8l36.7 23.7V480l-133-83.8L356 241.8zM440 75H226.3l-23 37.8 153.5 96.5L440 75zm-89 142.8L55.2 32v214.5l46 29L351 217.8zM97 294.2L8 437h213.7l125-200.5L97 294.2z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(ModxIconConfig);
//# sourceMappingURL=modx-icon.js.map